export default "__VITE_ASSET__7200de98__"